import { getPaginationLimit } from 'SharedPartialsLocal';
import Author from './ComposedAuthor';
import { AuthorQuery } from './AuthorQuery.graphql';

Author.query = AuthorQuery;
Author.queryVars = getPaginationLimit;

export default Author;
